// extracted by mini-css-extract-plugin
module.exports = {"navDropdown":"UUP5h","subitem":"Tiesc","navV2":"xrNNN","rightNav":"vXghh","spin":"lyK_K"};